import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b52b502"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-5 mt-4 px-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-danger d-flex text-white bg-danger",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lg fa-exclamation-circle mt-2 mt-sm-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "pl-3" }, " This feature not support for this type. ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "mb-3 mt-4"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col position-relative" }
const _hoisted_7 = { class: "pt-4 d-flex justify-content-center" }
const _hoisted_8 = {
  class: "dataTables_paginate paging_simple_numbers pl-4",
  id: "datatable_paginate"
}
const _hoisted_9 = { class: "pagination" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartJs = _resolveComponent("ChartJs")!

  return (_ctx.unsupportTypes.includes(_ctx.reportFilter.type))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ChartJs, {
              options: _ctx.option()
            }, null, 8, ["options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (items) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["paginate_button page-item", { active: items.active }]),
                  key: items
                }, [
                  (items.label == 'pagination.previous')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        "aria-controls": "datatable",
                        "data-dt-idx": "1",
                        tabindex: "0",
                        onClick: ($event: any) => (_ctx.changePage(items.url)),
                        class: "page-link"
                      }, _hoisted_12, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (items.label != 'pagination.previous' &&
              items.label != 'pagination.next'
              )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        "aria-controls": "datatable",
                        "data-dt-idx": "1",
                        tabindex: "0",
                        onClick: ($event: any) => (_ctx.changePage(items.url)),
                        class: "page-link"
                      }, _toDisplayString(items.label), 9, _hoisted_13))
                    : _createCommentVNode("", true),
                  (items.label == 'pagination.next')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        "aria-controls": "datatable",
                        "data-dt-idx": "1",
                        onClick: ($event: any) => (_ctx.changePage(items.url)),
                        tabindex: "0",
                        class: "page-link"
                      }, _hoisted_16, 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ])
        ])
      ]))
}